import { LuLoader } from 'react-icons/lu'
import { cn } from '@/shared/lib/utils'

interface SpinnerProps {
  className?: string
  size?: number
  label?: string
}

export function Spinner({
  className,
  size = 16,
  label = 'Loading',
}: SpinnerProps) {
  return (
    <LuLoader
      className={cn('animate-spin', className)}
      size={size}
      aria-label={label}
      role="status"
    />
  )
}
